import {
  ApolloClient,
  ApolloLink,
  InMemoryCache,
  ServerError,
  ServerParseError,
  from,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
// import { RetryLink } from '@apollo/client/link/retry';
import { createUploadLink } from 'apollo-upload-client';
import fetch from 'cross-fetch';
import { IMPORTANT_LOCAL_STORAGE_KEYS } from '@lon/shared/constants';
import { clearStorage, getLastDistrictBySignature } from '@lon/shared/utils';
import { OPENED_MODAL, REFETCH_APP_SETTINGS } from './vars';

const afterwareLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((response) => {
    if (response.errors) {
      for (const error of response.errors) {
        if (error?.extensions?.code === 401) {
          if (error?.extensions?.message === 'PASSWORD_EXPIRED') {
            OPENED_MODAL('PASSWORD_UPDATE');
          } else if (error?.extensions?.message === 'SESSION_EXPIRED') {
            OPENED_MODAL('SESSION_EXPIRED');
          } else {
            const lastDistrictBySignature = getLastDistrictBySignature();
            const adoptionEventCode =
              lastDistrictBySignature?.adoptionEventCode;

            clearStorage({
              exceptions: IMPORTANT_LOCAL_STORAGE_KEYS,
            });

            if (adoptionEventCode) {
              window.location.href = `/mathnation/login/review/${adoptionEventCode}`;
            } else {
              window.location.href = '/mathnation/login';
            }
          }
        }
      }
    }

    const context = operation.getContext();
    const {
      response: { headers },
    } = context;

    if (typeof headers === 'object') {
      if (headers.get('Application-Settings-Outdated')) {
        REFETCH_APP_SETTINGS(true);
      }
    }

    return response;
  });
});

const errorLink = onError(({ networkError }) => {
  const typedNetworkError = networkError as ServerError | ServerParseError;
  const statusCode = typedNetworkError?.statusCode;

  if (statusCode === 401) {
    const lastDistrictBySignature = getLastDistrictBySignature();
    const adoptionEventCode = lastDistrictBySignature?.adoptionEventCode;

    clearStorage({
      exceptions: IMPORTANT_LOCAL_STORAGE_KEYS,
    });

    if (adoptionEventCode) {
      window.location.href = `/mathnation/login/review/${adoptionEventCode}`;
    } else {
      window.location.href = '/mathnation/login';
    }
  }
});

const httpLink = createUploadLink({
  uri:
    process.env['NX_GRAPHQL_API_URL'] ||
    `${window.location.origin}/api/graphql`,
  fetch: process.env.NODE_ENV === 'test' ? fetch : undefined,
  credentials: 'include',
});

// const retryLink = new RetryLink({
//   delay: {
//     initial: 300,
//     max: Infinity,
//     jitter: true,
//   },
//   attempts: {
//     max: 3,
//     retryIf: (error, _operation) => !!error,
//   },
// });

const apolloClient = new ApolloClient({
  // @ts-ignore
  link: from([afterwareLink, errorLink, httpLink]),
  cache: new InMemoryCache(),
  credentials: 'include',
});

export default apolloClient;
